// extracted by mini-css-extract-plugin
export default {"submitRow":"create-or-edit_submitRow__rXHr7","tabHeader":"create-or-edit_tabHeader__s6t9t","tabHeaderWithNotification":"create-or-edit_tabHeaderWithNotification__3c1SU"};